import { INVOICE_KINDS, type InvoiceKind } from '../../shared/types';
import { Pill, SelectField } from './primitives';

export const invoiceKindLabel = (kind: InvoiceKind | null) => kind ? kind[0].toUpperCase() + kind.slice(1) : 'Other';
export const invoiceKindOptions = INVOICE_KINDS.map(value => ({ value, label: invoiceKindLabel(value) }));
export function InvoiceKindChip({ kind }: { kind: InvoiceKind | null }) {
  return <span className="invoice-kind-tag"><Pill>{invoiceKindLabel(kind)}</Pill></span>;
}
export function InvoiceKindSelect({ value, onChange }: { value: InvoiceKind | null; onChange: (value: InvoiceKind | null) => void }) {
  return <SelectField label="Kind" value={value ?? ''} items={[{ value: '', label: '—' }, ...invoiceKindOptions]}
    onChange={selected => {
      const next = selected ? selected as InvoiceKind : null;
      if (next !== value) onChange(next);
    }} />;
}
